import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import { getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewParticipation from "../components/ViewParticipation";
import ViewSolution from "../components/ViewSolution";
import ViewMetadata from "../components/ViewMetadata";
import Rendition from '../components/Rendition';


import SelectCapability from "../components/SelectCapability";
import SelectRole from "../components/SelectRole";

import {getSolution, getParticipation, addParticipationToSolution, editParticipation} from "../utils/utilsSolution";


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Participation extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }


    }
    
    loadSolution(id){

        let StateChange = {};
        StateChange.Solution = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Solution = data;
            StateChange.renderState = "loaded";
            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Solution = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getSolution(this.dsd, id,onLoad, onFail);
        }

        this.setState(StateChange);

        return;                
    };

    loadParticipation(id){

        let StateChange = {};
        StateChange.Role = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Participation = data;

            StateChange.FormData = data;

            if (data.Solution){
                StateChange.Solution = data.Solution;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsSolution(data.Solution._id);
                }

            }

            StateChange.renderState = "loaded";

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.Participation.Solution.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot add or edit this Participation"
                    break;
                }
            }

            this.setState(StateChange);

            this.fetchViz(id);

            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Participation = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getParticipation(this.dsd, id,onLoad, onFail);
        }

        this.setState(StateChange);

        return;           
    };

    fetchViz(id) {

       const onDoneDot = function(dot) {
           this.setState({ dot: dot });
       }.bind(this);

       const onFailDot = function(error) {
           console.error('Failed to fetch DOT:', error);
       }.bind(this);

       getParticipation(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

   };


    setup(){

        let StateChange = {

            mode: "view",

            idParticipation: null,
            idSolution: null,

            Solution: null,
            Participation: null,

            isUpdated: false,

            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {},
            OfferEdit:false,
            fallbackpath: null,

            Controls: {
            },

            vizNodeId: null,
            dot: null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idParticipation = getParam('id', this.props);
        StateChange.idSolution = getParam('idSolution', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idSolution){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Solution not specified when adding a Participation"
                }
                break;
            default:
                if (StateChange.idSolution){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Solution should not be specified for an existing Participation"
                }
                if (!StateChange.idParticipation){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Participation not specified"
                }
                break;
        }


        if (StateChange.idSolution){
            this.loadSolution(StateChange.idSolution);
        }
        if (StateChange.idParticipation){
            this.loadParticipation(StateChange.idParticipation);
        }

        if (this.props.location.state && this.props.location.state.fallbackpath){
            StateChange.fallbackpath = this.props.location.state.fallbackpath;
        }
        else{
            if (StateChange.mode == "new"){
                if (StateChange.idSolution){
                    StateChange.fallbackpath = `/solution/${StateChange.idSolution}`;
                }        
            }
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        

                if (FormFieldName == 'type'){
                    if (FormFieldValue){
                        if (!FormData.name){
                            FormData.name = `<<${FormFieldValue}>>`;
// note that the iput in render has a key property to force it to rerender when the type changes.
                        }
                    }
                }
    

                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.renderState = "error";

            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        for (const field in e.response.data.fields){
                            StateChange.invalidFields = e.response.data.fields
                        }
    
                    }
                }
            }
    
            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0, 0);


        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/participation/${this.state.idParticipation}`);
                        break;
                    case "new":
                        if (this.state.fallbackpath){
                            this.props.navigation(`${this.state.fallbackpath}`);
                        }
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })

                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(idParticipation){
                            this.props.navigation(`/participation/${idParticipation}`);
                            return;
                        }.bind(this);

                        addParticipationToSolution(this.dsd, this.state.idSolution,this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/participation/${this.state.idParticipation}`);
                           return;
                        }.bind(this);

                        editParticipation(this.dsd, this.state.idParticipation,this.state.FormData, onUpdate, onError);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;

        let target = null;
        if (event.target.tagName == "a"){
            target = event.target;
        } else{
            if ("parentElement" in event.target){
                if (event.target.parentElement.tagName == "a"){
                    target = event.target.parentElement;
                }
            }
        }

        if (target){
            if ("href" in target){
                idNode = target.href.baseVal;
                StateChange.vizNodeId = idNode;
            }
        }
        

        if (!idNode){
            return;
        }
        
        let partsVizNodeId = idNode.split('_');
        switch(partsVizNodeId[0]){
            case 'capability':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/capability/${partsVizNodeId[1]}`);
                }
                break;
            case 'role':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/role/${partsVizNodeId[1]}`);
                }
                break;
            case 'system':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/system/${partsVizNodeId[1]}`);
                }
                break;
            case 'participation':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/participation/${partsVizNodeId[1]}`);
                }
                break;
    
        }

        this.setState(StateChange);

        event.preventDefault();

    };


    visualise(){
    
        if (!this.state.Participation){
            return null;
        }

        try {

            const images = this.dsd.getSolutionImages();

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot} images={images}/>
                    </div>
                </div>
            );
          } catch (error) {
            return <div/>
          }
    };

    showError(){


        if (this.state.invalidFields){
            return(
                <>
                    {
                        Object.keys(this.state.invalidFields).map(
                        (field, pos) => 
                            {
                                let error = this.state.invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        return "ERROR - Failed to Update";

    }


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        let idSolution = null;
                        if (this.state.Solution){
                            idSolution = this.state.Solution._id;
                        }

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Participation</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                                }

                                <form> 

                                    <fieldset>
                                        <legend>Select the Role</legend>
                                        <SelectRole label='Role' name="idRole" onChange={this.handleChange} idSolution={idSolution} value={this.state.FormData.idRole}/>
                                    </fieldset>


                                    <fieldset>
                                        <legend>Select the Capability</legend>
                                        <SelectCapability label='Capability' name="idCapability" onChange={this.handleChange} idSolution={idSolution} value={this.state.FormData.idCapability}/>
                                    </fieldset>


                                    <PD.Input key={this.state.FormData.type} label="Participates by" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Select label="Type" name='type'  onChange={this.handleChange} value={this.state.FormData.type}>
                                        {
                                            Object.keys(this.dsd.config.ParticipationTypes).map(
                                                (type, posType) => 
                                                    {
                                                        return(
                                                            <option key={posType} value={type}>{type}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>



                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.ParticipationStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Participation</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewParticipation Participation={this.state.Participation}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Participation:{this.state.Participation.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewParticipation Participation={this.state.Participation}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Visualise'>
                                        {this.visualise()}
                                    </div>

                                    <div label='Solution'>
                                        <ViewSolution Solution={this.state.Solution} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Participation} />
                                    </div>


                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/participations"
                                            id={this.state.idParticipation}
                                        />
                                    </div>



                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };
}


// Wrap and export
export default function Participation_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Participation {...props} navigation={navigation} location={location} params={params} />;
  }
